import { FC, useContext } from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
// ** Gatsby
// ** Custom Components
import Container from "../../components/Container"
import SwiperSlider from "../../components/SwiperSlider"
import Text from "../../components/Text"
import Box from "../../components/Box"
import PostsGrid from "../../components/PostsGrid"
import { IGatsbyImageData } from "gatsby-plugin-image"
import { PortableText } from "@portabletext/react"
import { serializers } from "../../components/Serializers"
import PageContext from "../../contexts/PageContext"

type cardType = {
  title: string
  type: string
  image: IGatsbyImageData
  link: string
}
interface Props {
  cards: cardType[]
  lang: "en" | "fr"
  topics: { [key: string]: string }
  currentTopic: string
}

const SectionKnowledgeHub: FC<Props> = ({
  cards,
  topics,
  currentTopic,
  lang,
}) => {
  const data = useStaticQuery(graphql`
    query {
      allSanityPage(filter: { title: { eq: "Blog-Page" } }) {
        nodes {
          slug {
            current
          }
          i18n_lang
          _rawContent(resolveReferences: { maxDepth: 10 })
        }
      }
    }
  `)
  const page = useContext(PageContext);

  let heading
  data?.allSanityPage?.nodes?.map((node: any) => {
    if (node.i18n_lang === page.i18n_lang) {
      heading = node._rawContent
    }
  })
  return (
    <Container fullWidthOnMobile={false} constrainedToBreakPoint>
      <div className="w-full text-center">
        {heading && <PortableText value={heading} components={serializers} />}
      </div>

      <Box className="mt-12 lg:mt-24">
        <Box className="flex flex-col gap-y-4 justify-between lg:flex-row gap-x-4 items-center">
          <Box className="w-full lg:flex-1 flex justify-center px-4 overflow-hidden max-w-full lg:w-auto">
            <SwiperSlider
              pagination={false}
              navigation={false}
              slidesPerView="auto"
              className="[&>.swiper-wrapper]:py-0 !mx-0"
              childClassName="overflow-hidden max-w-max"
            >
              {topics &&
                Object.keys(topics).map((item: string, index: number) => (
                  <Link
                    to={`${lang === "fr" ? "/fr/" : "/"}${item}`}
                    key={index}
                    className={`block cursor-pointer py-2 px-6 border border-opacity-25 rounded-3xl ${
                      currentTopic === item
                        ? "bg-blue-500"
                        : "bg-gray-300 bg-opacity-10"
                    }`}
                  >
                    <Text
                      variant="body-copy"
                      className={`font-semibold ${
                        currentTopic === item ? "text-white" : "text-blue-500"
                      }`}
                    >
                      {Object.values(topics)[index]}
                    </Text>
                  </Link>
                ))}
            </SwiperSlider>
          </Box>
        </Box>
      </Box>

      <Box className="w-full overflow-hidden lg:w-full px-4 mt-8 lg:mt-16">
        <PostsGrid cards={cards} />
      </Box>
    </Container>
  )
}

export default SectionKnowledgeHub
